import { API } from "../../API";
import { notify } from "react-notify-toast";
import {
  teacherResponse,
  teacherStatus,
  getClass,
  dateToISO,
} from "../../Helper";
import moment from "moment";

export const getRefId = (booking) => {
  return booking._id + (booking.split_index ? `_${booking.split_index}` : "");
};

export const scrollToJob = (refs) => {
  var focus_ref = {};
  let hash = window.location.hash;

  if (hash) {
    let id = hash.slice(1);
    // let index = Object.keys(refs).indexOf(id)
    // let page = Math.ceil((index + 1) / 5);
    // if (page > 1) {
    //   handlePage(page, rowsOption, allBookings);
    // }
    focus_ref = refs[id] || {};
    // console.log(focus_ref)
  }

  // console.log(refs, hash.slice(1), focus_ref)

  if (focus_ref.current) {
    //   console.log('scroll')
    focus_ref.current.scrollIntoView({
      block: "start",
    });
  }
};

// // seems like this JS file has not been imported anywhere

// import React from "react"
// import axios from "axios"
// import { PORT } from "../../config"

// import { useEffect, useState } from "react"

// const JobsData = () => {
//   const [data, setData] = useState("")
//   let [bookings, setBookings] = useState([])
//   let [events, setEvents] = useState([])

//   useEffect(() => {
//     try {
//       axios({
//         method: "get",
//         url: `${PORT}/getBookingsByTeacherID`,
//       })
//         .then(function (result) {
//           setBookings(result.data)
//           axios
//             .get(`${PORT}/listAllBookings`)
//             .then((res) => {
//               // window.localStorage.setItem("allbookings", JSON.stringify(res.data));
//               setEvents(res.data.data)
//             })
//             .catch((err) => {
//               console.log("Allbookings.js: ", err)
//             })
//         })
//         .catch(function (err) {
//           console.log(err)
//         })
//     } catch (error) {
//       alert(error)
//     }
//   }, [])

//   // current booking field has no firstname, mobile, email, class_id and class_type - lieh
//   const getTeacherFromEvent = (event, booking) => {
//     return {
//       first_name: event.summary.split(" ")[0],
//       last_name: event.summary.split(" ")[1],
//       start_time: event.start.dateTime,
//       end_time: event.end.dateTime,
//       manager: booking.email,
//       manager_name: booking.first_name,
//       // real field booking_id is used here - lieh
//       booking_id: booking.booking_id,
//       mobile_no: booking.mobile,
//       class: booking.class_id,
//       class_type: booking.class_type,
//       teacher_id:
//         event.summary.split(" ")[0] + "_" + event.summary.split(" ")[1],
//     }
//   }

//   // Make joblist entiry using mapping event and booking data
//   const mapData = () => {
//     const mapped_data = []
//     for (var i = 0; i < bookings.length; i++) {
//       for (var j = 0; j < events.length; j++) {
//         if ((events[j] && events[i].start.date) !== undefined) {
//           if (events[j].start.date.split("T")[0] === bookings[i].booking_date) {
//             mapped_data.push(getTeacherFromEvent(events[j], bookings[i]))
//           }
//         } else if ((events[j] && events[i].start.dateTime) !== undefined) {
//           if (
//             events[j].start.dateTime.split("T")[0] === bookings[i].booking_date
//           ) {
//             mapped_data.push(getTeacherFromEvent(events[j], bookings[i]))
//           }
//         }
//       }
//     }

//     console.log(mapped_data)
//   }
//   mapData()
//   return <div>{bookings.length + " --------" + events.length}</div>
// }

// export default JobsData

export const handleMultiDateBookings = (list, teacher_id) => {
  const newList = [];

  list.forEach((booking) => {
    if (booking.multiple_date && booking.splits.length) {
      // const splits = booking.splits.filter((sp) => sp.teacher_id === user._id)
      booking.splits.forEach((split, index) => {
        if (split.teacher_id === teacher_id) {
          let newBooking = { ...booking };
          newBooking.booking_date = split.date_from;
          newBooking.end_booking_date = split.date_to;
          newBooking.teacher_status = split.teacher_status;
          newBooking.teacher_response = split.teacher_response;
          newBooking.cancelled_by_inst = split.cancelled_by_inst;
          newBooking.teacher_cancel_reason = split.teacher_cancel_reason;
          newBooking.split_index = index;
          newList.push(newBooking);
        }
      });
    } else {
      newList.push(booking);
    }
  });

  return newList;
};

export const handleCollegeMultiDateBookings = (list) => {
  const newList = [];

  list.forEach((booking) => {
    if (booking.multiple_date && booking.splits.length) {
      booking.splits.forEach((split, index) => {
        let newBooking = { ...booking };
        newBooking.teacher_id = split.teacher_id;
        newBooking.booking_date = split.date_from;
        newBooking.end_booking_date = split.date_to;
        newBooking.teacher_status = split.teacher_status;
        newBooking.teacher_response = split.teacher_response;
        newBooking.cancelled_by_inst = split.cancelled_by_inst;
        newBooking.split_index = index;
        newList.push(newBooking);
      });
    } else {
      newList.push(booking);
    }
  });

  return newList;
};

export const submitResponse = (
  allBookings,
  handleBookings,
  teacher_id,
  booking_id,
  teacher_response,
  multiple_date,
  split_index,
  teacher_cancel_reason
) => {
  // console.log(allBookings, teacher_id, booking_id, teacher_response, multiple_date, split_index, teacher_cancel_reason)

  if (multiple_date) {
    // console.log(teacher_id, booking_id, teacher_response)
    return API.respondToBookingMultipleDate(
      teacher_id,
      booking_id,
      teacher_response,
      split_index,
      teacher_cancel_reason
    )
      .then((result) => {
        const { update, msg } = result.data;
        if (!update) {
          notify.show(msg);
        } else {
          let newBookings = allBookings.reduce((result, job) => {
            if (job._id === booking_id && job.split_index === split_index) {
              job.teacher_status = teacherStatus.responded;
              job.teacher_response = teacher_response;
              job.teacher_cancel_reason = teacher_cancel_reason;
            }
            result.push(job);
            /*if (job.teacher_response !== teacherResponse.rejected) {
                            result.push(job);
                        }*/

            return result;
          }, []);

          handleBookings(newBookings);
          notify.show(`Booking ${teacher_response} successfully`);
        }
      })
      .catch((err) => {
        console.log("err: ", err.response || err);

        if (err?.response?.data?.err) {
          notify.show(err.response.data.err)
        }
      });
  } else {
    return API.respondToBooking(
      teacher_id,
      booking_id,
      teacher_response,
      teacher_cancel_reason
    )
      .then((result) => {
        const { update, msg } = result.data;
        // console.log(result)
        if (!update) {
          notify.show(msg);
        } else {
          let newBookings = allBookings.reduce((result, job) => {
            if (job._id === booking_id) {
              job.teacher_status = teacherStatus.responded;
              job.teacher_response = teacher_response;
              job.teacher_cancel_reason = teacher_cancel_reason;
            }
            result.push(job);
            /*if (job.teacher_response !== teacherResponse.rejected) {
                            result.push(job);
                        }*/

            return result;
          }, []);
          handleBookings(newBookings);
          notify.show(`Booking ${teacher_response} successfully`);
        }
      })
      .catch((err) => {
        console.log("err: ", err);

        if (err?.response?.data?.err) {
          notify.show(err.response.data.err)
        }
      });
  }
};

export const cancelBooking = (
  allBookings,
  handleBookings,
  teacher_id,
  booking_id,
  multiple_date,
  split_index
) => {
  // console.log(allBookings, teacher_id, booking_id, teacher_response, multiple_date, split_index)

  if (multiple_date) {
    // console.log(teacher_id, booking_id, teacher_response)
    API.teacherCancelBookingMultipleDate(teacher_id, booking_id, split_index)
      .then((result) => {
        const { update, msg } = result.data;
        if (!update) {
          notify.show(msg);
        } else {
          let newBookings = allBookings.reduce((result, job) => {
            if (job._id === booking_id && job.split_index === split_index) {
              job.teacher_status = teacherStatus.responded;
              job.teacher_response = teacherResponse.cancelled;
            }
            result.push(job);
            /*if (job.teacher_response !== teacherResponse.rejected) {
                            result.push(job);
                        }*/

            return result;
          }, []);

          handleBookings(newBookings);
          notify.show(`Booking cancelled successfully`);
        }
      })
      .catch((err) => {
        console.log("err: ", err.response);
      });
  } else {
    API.teacherCancelBooking(teacher_id, booking_id)
      .then((result) => {
        const { update, msg } = result.data;

        if (!update) {
          notify.show(msg);
        } else {
          let newBookings = allBookings.reduce((result, job) => {
            if (job._id === booking_id) {
              job.teacher_status = teacherStatus.responded;
              job.teacher_response = teacherResponse.cancelled;
            }
            result.push(job);
            /*if (job.teacher_response !== teacherResponse.rejected) {
                            result.push(job);
                        }*/

            return result;
          }, []);
          handleBookings(newBookings);
          notify.show(`Booking cancelled successfully`);
        }
      })
      .catch((err) => {
        console.log("err: ", err);
      });
  }
};

export const statusList = [
  { value: "status-all", label: "Show All" },
  { value: "unresponded", label: "Unresponded" },
  { value: "accepted", label: "Accepted" },
  { value: "rejected", label: "Rejected" },
  { value: "cancelled", label: "Cancelled" },
];

export const statusListCollege = [
  { value: "status-all", label: "Show All" },
  { value: "mine", label: "Made By Me" },
  { value: "others", label: "Made By Others" },
  { value: "cancelled", label: "Cancelled" },
  { value: "allocation-in-progress", label: "Allocation in-Progress" },
];

export const dateList = [
  { value: "date-all", label: "Show All" },
  { value: "in-progress", label: "In-progress" },
  { value: "future", label: "Future" },
  { value: "past", label: "Past" },
];

export const modeList = [
  { value: "mode-all", label: "Show All" },
  { value: "online", label: "Online" },
  { value: "on campus", label: "On Campus" },
];

export const sortListAll = [
  { value: "sort-date-desc", label: "Earliest" },
  { value: "sort-date-asc", label: "Oldest" },
];

export const sortListPast = [
  { value: "sort-date-desc", label: "Most Recent" },
  { value: "sort-date-asc", label: "Oldest" },
];

export const filterByStatus = (list, status, user_id) => {
  let filteredBookings = list;
  switch (status) {
    case "unresponded":
    case "accepted":
    case "rejected":
      filteredBookings = filteredBookings.filter((booking) => {
        return (
          booking.teacher_response === status && !booking.cancelled_by_inst
        );
      });
    case "cancelled":
      filteredBookings = filteredBookings.filter((booking) => {
        if (user_id) {
          return booking.cancelled_by_inst
        } else {
          return booking.teacher_response === status || booking.cancelled_by_inst;
        }
      });
      break;
    case "mine":
      filteredBookings = filteredBookings.filter((booking) => {
        return booking.booking_maker === user_id;
      });
      break;
    case "others":
      filteredBookings = filteredBookings.filter((booking) => {
        return booking.booking_maker !== user_id;
      });
      break;
    case "allocation-in-progress":
      filteredBookings = filterByDate(filteredBookings, "future").filter((booking) => {
        return booking.teacher && Object.keys(booking.teacher).length === 0 && !booking.cancelled_by_inst
      });
      break;
    case "status-all":
    default:
      break;
  }
  // if (status !== "status-all") {
  //     filteredBookings = filteredBookings.filter((booking) => {
  //         return booking.teacher_response === status
  //     })
  // }
  return filteredBookings;
};

export const filterByDate = (list, date) => {
  let filteredBookings = list;
  const today = new Date();
  const today_date = dateToISO(today);
  const today_time = `${today
    .getHours()
    .toString()
    .padStart(2, "0")}:${today.getMinutes().toString().padStart(2, "0")}`;

  if (date !== "date-all") {
    filteredBookings = filteredBookings.filter((booking) => {
      let match = true;
      if (date === "in-progress") {
        if (
          booking.end_booking_date &&
          booking.booking_date !== booking.end_booking_date
        ) {
          match =
            (booking.booking_date < today_date ||
              (booking.booking_date === today_date &&
                booking.arrival_time < today_time)) &&
            (booking.end_booking_date > today_date ||
              (booking.end_booking_date === today_date &&
                booking.end_time > today_time));
        } else {
          match =
            booking.booking_date === today_date &&
            booking.arrival_time < today_time &&
            booking.end_time > today_time;
        }
      } else if (date === "past") {
        let compare_date = booking.end_booking_date || booking.booking_date;
        match =
          compare_date < today_date ||
          (compare_date === today_date && booking.end_time < today_time);
      } else if (date === "future") {
        match =
          booking.booking_date > today_date ||
          (booking.booking_date === today_date &&
            booking.start_time > today_time);
      } else if (moment(date, "YYYY-MM-DD", true).isValid()) {
        match = booking.booking_date <= moment(date).format("YYYY-MM-DD") && booking.end_booking_date >= moment(date).format("YYYY-MM-DD")
      }
      // console.log(booking.booking_date, booking.end_booking_date, match)
      return match;
    });
  }

  return filteredBookings;
};

export const filterByDateRangeOrSpecificDate = (list, date) => {
  let filteredBookings = list;
  const today = new Date();
  const today_date = dateToISO(today);
  const today_time = `${today
    .getHours()
    .toString()
    .padStart(2, "0")}:${today.getMinutes().toString().padStart(2, "0")}`;

  if (date !== "date-all") {
    filteredBookings = filteredBookings.filter((booking) => {
      let match = true;
      if (date === "in-progress") {
        if (
          booking.end_booking_date &&
          booking.booking_date !== booking.end_booking_date
        ) {
          match =
            (booking.booking_date < today_date ||
              (booking.booking_date === today_date &&
                booking.arrival_time < today_time)) &&
            (booking.end_booking_date > today_date ||
              (booking.end_booking_date === today_date &&
                booking.end_time > today_time));
        } else {
          match =
            booking.booking_date === today_date &&
            booking.arrival_time < today_time &&
            booking.end_time > today_time;
        }
      } else if (date === "completed") {
        let compare_date = booking.end_booking_date || booking.booking_date;
        match =
          compare_date < today_date ||
          (compare_date === today_date && booking.end_time < today_time);
      } else if (date === "future") {
        match =
          booking.booking_date > today_date ||
          (booking.booking_date === today_date &&
            booking.start_time > today_time);
      } else if (moment(date, "DD-MM-YYYY", true).isValid()) {
        match = booking.booking_date <= moment(date, "DD-MM-YYYY").format("YYYY-MM-DD") && 
                booking.end_booking_date >= moment(date, "DD-MM-YYYY").format("YYYY-MM-DD")
      }
      return match;
    });
  }
  return filteredBookings;
};

export const filterByMode = (list, mode) => {
  let filteredBookings = list;
  if (mode) {
    filteredBookings = filteredBookings.filter((booking) => {
      let result = booking.online ? "online" : "on campus"
      result = result.toLowerCase();
      return result.includes(mode === "mode-all" ? "" : mode);
    });
  }
  return filteredBookings;
}

export const filterByCampus = (list, campus, allCampuses) => {
  let filteredBookings = list;
  if (campus) {
    filteredBookings = filteredBookings.filter((booking) => {
      const jobCampus = allCampuses.find((campus) => campus._id === booking.campus_id);
      const result = jobCampus ? jobCampus.reference_name : ""
      return result.includes(campus === "campus-all" ? "" : campus);
    });
  }
  return filteredBookings;
}

export const filterByKeyword = (
  list,
  keyword,
  allCampus,
  allInst,
  allTeachers
) => {
  let filteredBookings = list;

  // console.log(allTeachers);

  if (keyword) {
    const classList = getClass();

    filteredBookings = filteredBookings.filter((booking) => {
      let level = classList.find((cl) => cl.key === booking.level);
      level = level ? level.whole_name : booking.level;
      const jobCampus = allCampus.find(
        (campus) => campus._id === booking.campus_id
      );
      const jobInst = jobCampus
        ? allInst.find((inst) => inst._id === jobCampus.institution_id)
        : null;
      const jobTeacher = allTeachers.find(
        (teacher) => teacher._id === booking.teacher._id
      );

      // console.log(allTeachers);
      // console.log("This is booking teacher: ", booking);

      let result =
        booking.level +
        level +
        (jobInst ? jobInst.institution_name : "") +
        (!booking.cancelled_by_inst && jobTeacher
          ? jobTeacher.first_name + (jobTeacher.preferred_name ? jobTeacher.preferred_name : "") + jobTeacher.last_name
          : "");
      result = result.toLowerCase();
      return result.includes(keyword);
    });
  }
  return filteredBookings;
};

export const onlineClassCancelReasons = [
  {
    value: "technical-issues",
    description: "I am experiencing technical issues at home",
    allowCancel: false,
  },
  { value: "unwell-teacher", description: "I am unwell", allowCancel: true },
  {
    value: "online-material-expectations",
    description: "I don't understand the lesson material and expectations",
    allowCancel: false,
  },
  {
    value: "preparation-time",
    description: "I need more time to prepare",
    allowCancel: false,
  },
];

export const inPersonClassCancelReasons = [
  {
    value: "late-arrival",
    description: "I'm going to be late",
    allowCancel: false,
  },
  {
    value: "flu-unwell-teacher",
    description: "I have flu-like symptoms or I am unwell",
    allowCancel: true,
  },
  {
    value: "material-expectations",
    description: "I don't understand the lesson material and expectations",
    allowCancel: false,
  },
  {
    value: "child-unwell",
    description: "My child is unwell and I am carer",
    allowCancel: true,
  },
];

export const invoiceVariationReasons = [
  {
    value: 'teacher-late-arrival',
    description: 'Teacher late arrival'
  },
  {
    value: 'teacher-early-departure',
    description: 'Teacher early departure'
  },
  {
    value: 'teacher-no-show',
    description: 'Teacher no show'
  },
  {
    value: 'student-early-departure',
    description: 'Students early departure'
  },
  {
    value: 'booking-date-incorrect',
    description: 'Booking dates incorrect'
  },
  {
    value: 'canceled-by-admin',
    description: 'Class is canceled by ReadyTeacher admin'
  },
  {
    value: 'canceled-by-inst',
    description: 'Class is canceled by institution'
  },
  {
    value: 'teacher-work-longer',
    description: 'Teacher worked longer than scheduled'
  },
  {
    value: 'request-booking-fee-discount',
    description: 'Request booking fee discount'
  }
];

export const invoiceBookingFeesReason = [
  {
    value: 'select-program',
    description: 'Select program'
  },
  {
    value: 'class-not-consistent',
    description: 'Class is not consistent on all days'
  }
];

export const invoiceBookingFees = [
  'Booking Fee - Same Day; Weekends',
  'Booking Fee - Within 24 hours of commencement',
  'Booking Fee - Outside 24 hours of commencement',
  'Peak Period Surcharge'
];

export const invoiceDiscountReason = [
  {
    value: 'late-arrival',
    description: 'Late arrival'
  },
  {
    value: 'early-departure',
    description: 'Early departure'
  },
  {
    value: 'welcome-discount',
    description: 'Welcome discount'
  },
];

export const cancellationReasons = onlineClassCancelReasons.concat(
  inPersonClassCancelReasons
);
